import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeatureFlagService } from '@core/services/feature-flag/feature-flag.service';
import { FeatureFlagName } from '@core/typings/feature-flag.typing';

/**
 * Guards access to the Impact Reporting route.
 * Checks if the TrueImpactReporting feature flag is enabled.
 * The parent route's resolvers ensure that activeNpo and featureFlags are loaded by the time the component renders.
 */
export const impactReportingAccessGuard: CanActivateFn = () => {
  const router = inject(Router);
  const featureFlagService = inject(FeatureFlagService);

  return featureFlagService.getAllFeatureFlagsLookup().then(() => {
    const isEnabled = featureFlagService.getFeatureFlagEnabledValue(FeatureFlagName.TrueImpactReporting);

    if (isEnabled) {
      return true;
    }

    return router.parseUrl('/forbidden');
  });
};